import React from "react";
import FileInput from "../fileInput/FileInput";
import { useTranslator } from "context/translator";
import FormError from "components/formError/FormError";

const DocumentForm = ({ data, onChange, form }) => {
  const { translate } = useTranslator();

  const update = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const handleDelete = () => {
    onChange({ ...data, status: !data.status });
  };

  return (
    <div className="border rounded-xl p-4 space-y-4 bg-white dark:bg-gray-900 shadow">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold text-lg dark:text-white">
          {translate("document")}
        </h3>

        {data?._id && (
          <>
            {data.status ? (
              <button
                type="button"
                onClick={handleDelete}
                className="text-red-600 text-sm"
              >
                {translate("deactivate-card")}
              </button>
            ) : (
              <button
                type="button"
                onClick={handleDelete}
                className="text-green-600 text-sm"
              >
                {translate("activate-card")}
              </button>
            )}
          </>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
        <div>
          <label className="label">{translate("document-name")}</label>
          <input
            type="text"
            value={data.documentName}
            onChange={(e) => update("documentName", e.target.value)}
            className="input"
            required
          />
          <FormError form={form} name="documentName" />
        </div>
        <div>
          <label className="label">{translate("document-details")}</label>
          <textarea
            value={data.documentDetails}
            onChange={(e) => update("documentDetails", e.target.value)}
            className="input"
            required
          />
          <FormError form={form} name="documentDetails" />
        </div>
      </div>

      {/* Files */}
      <FileInput
        label={translate("card-files")}
        files={data.files}
        onAdd={(newFiles) => update("files", [...data.files, ...newFiles])}
        onRemove={(idx) =>
          update(
            "files",
            data.files.filter((_, i) => i !== idx)
          )
        }
      />
    </div>
  );
};

export default DocumentForm;
